"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientSourceRoutes = void 0;
var ClientSourceRoutes;
(function (ClientSourceRoutes) {
    ClientSourceRoutes["BasePrefix"] = "client-sources";
    ClientSourceRoutes["ById"] = ":clientSourceId";
    ClientSourceRoutes["All"] = "all";
    ClientSourceRoutes["List"] = "list";
})(ClientSourceRoutes = exports.ClientSourceRoutes || (exports.ClientSourceRoutes = {}));
